export const GET_PICKUP_STORES_API = '/stores/{{StoreId}}/{{language}}/cnc/pickup-stores';
